import { NgModule } from '@angular/core';
import {CommonModule, NgForOf, NgIf, NgOptimizedImage} from '@angular/common';
import { MainComponent } from './main.component';
import {HeaderComponent} from "./components/header/header.component";
import {FooterComponent} from "./components/footer/footer.component";
import {HomeComponent} from "./pages/home/home.component";
import {SidebarStructureComponent} from "./components/sidebar-structure/sidebar-structure.component";
import {SidebarComponent} from "./components/sidebar/sidebar.component";
import {SelectedGameComponent} from "./pages/selected-game/selected-game.component";
import {SelectedCategoryComponent} from "./pages/games/selected-category/selected-category.component";
import {SelectedProviderComponent} from "./pages/games/selected-provider/selected-provider.component";
import {NotFoundComponent} from "./pages/not-found/not-found.component";
import {LegalSectionComponent} from "./pages/legal/legal-section/legal-section.component";
import {ProvidersComponent} from "./pages/games/gameProviders/providers.component";
import {FilterByTermPipe} from "../pipes/filterByTerm.pipe";
import {ChunkifyPipe} from "../pipes/chunkify.pipe";
import {AboutComponent} from "./pages/legal/about/about.component";
import {FaqComponent} from "./pages/legal/faq/faq.component";
import {SupportComponent} from "./pages/legal/support/support.component";
import {BitcoinComponent} from "./pages/legal/bitcoin/bitcoin.component";
import {ResponsibleGamingComponent} from "./pages/legal/responsible-gaming/responsible-gaming.component";
import {PrivacyComponent} from "./pages/legal/privacy/privacy.component";
import {AmlComponent} from "./pages/legal/aml/aml.component";
import {BankingComponent} from "./pages/legal/banking/banking.component";
import {CookiePolicyComponent} from "./pages/legal/cookie-policy/cookie-policy.component";
import {SecurityComponent} from "./pages/legal/security/security.component";
import {ItemShowcaseComponent} from "./components/item-showcase/item-showcase.component";
import {CafComponent} from "./pages/legal/banking/caf/caf.component";
import {LeaderboardComponent} from "./pages/leaderboard/leaderboard.component";
import {RegistrationInLobbyComponent} from "./pages/registration-in-lobby/registration-in-lobby.component";
import {PlayGameComponent} from "./pages/selected-game/play-game/play-game.component";
import {CarouselComponent} from "./components/carousel/carousel.component";
import {PromotionsComponent} from "./pages/promotions/promotions.component";
import {PromoSlideComponent} from "./components/promo-slide/promo-slide.component";
import {LegacyComponent} from "./pages/legacy/legacy.component";
import {RecentGamesComponent} from "./components/recent-games/recent-games.component";
import {
  ResetForgotPasswordInLobbyComponent
} from "./components/reset-forgot-password-in-lobby/reset-forgot-password-in-lobby.component";
import {AlwaysoneComponent} from "./pages/alwaysone/alwaysone.component";
import {UnsubscribeComponent} from "./pages/unsubscribe/unsubscribe.component";
import {MainRoutingModule} from "./main-routing.module";
import {TranslateModule} from "@ngx-translate/core";
import {RouterLink, RouterOutlet} from "@angular/router";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CarouselModule} from "ngx-owl-carousel-o";
import { RecommendedGamesComponent } from './components/recommended-games/recommended-games.component';
import { GameChunkComponent } from './components/game-chunk/game-chunk.component';
import { FavouriteGamesComponent } from './components/favourite-games/favourite-games.component';
import { LikeLabelComponent } from './components/like-label/like-label.component';
import { GameItemComponent } from './components/game-chunk/game-item/game-item.component';
import { SearchbarComponent } from './components/searchbar/searchbar.component';
import { RecommendedComponent } from './pages/games/recommended/recommended.component';
import { RecentComponent } from './pages/games/recent/recent.component';
import { FavouritesComponent } from './pages/games/favourites/favourites.component';
import {PromoDetailsComponent} from "./pages/promotions/promo-details/promo-details.component";
import { ProvidersCarouselComponent } from './components/providers-carousel/providers-carousel.component';
import {ChatComponent} from "./components/chat/chat.component";
import {ChatDatePipe} from "../pipes/chatDate.pipe";
import {ChatMessageTextPipe} from "../pipes/chatMessageText.pipe";
import {ChatReplaceUserEmail} from "../pipes/chatReplaceUserEmail.pipe";
import {ComplaintsFormComponent} from "./pages/legal/complaints-form/complaints-form.component";
import {SharedModule} from "../shared/shared.module";


@NgModule({
    declarations: [
        MainComponent,
        HeaderComponent,
        FooterComponent,
        HomeComponent,
        SidebarComponent,
        SelectedGameComponent,
        NotFoundComponent,
        FilterByTermPipe,
        ChunkifyPipe,
        SelectedProviderComponent,
        ProvidersComponent,
        SelectedCategoryComponent,
        LegalSectionComponent,
        AboutComponent,
        FaqComponent,
        SupportComponent,
        BitcoinComponent,
        ResponsibleGamingComponent,
        PrivacyComponent,
        AmlComponent,
        BankingComponent,
        CookiePolicyComponent,
        SecurityComponent,
        ItemShowcaseComponent,
        CafComponent,
        LeaderboardComponent,
        SidebarStructureComponent,
        RegistrationInLobbyComponent,
        PlayGameComponent,
        CarouselComponent,
        PromotionsComponent,
        PromoSlideComponent,
        LegacyComponent,
        RecentGamesComponent,
        ResetForgotPasswordInLobbyComponent,
        AlwaysoneComponent,
        UnsubscribeComponent,
        RecommendedGamesComponent,
        GameChunkComponent,
        FavouriteGamesComponent,
        LikeLabelComponent,
        GameItemComponent,
        SearchbarComponent,
        RecommendedComponent,
        RecentComponent,
        FavouritesComponent,
        PromoDetailsComponent,
        ProvidersCarouselComponent,
      ChatComponent,
      ComplaintsFormComponent
    ],
  imports: [
    CommonModule,
    MainRoutingModule,
    TranslateModule,
    RouterOutlet,
    FormsModule,
    NgIf,
    ReactiveFormsModule,
    RouterLink,
    NgForOf,
    NgOptimizedImage,
    CarouselModule,
    ChatDatePipe,
    ChatMessageTextPipe,
    ChatReplaceUserEmail,
    SharedModule
  ]
})
export class MainModule { }
